export default __webpack_public_path__ + "static/media/kitchen3-afterG-768w.e0038f40.avif";